export const teamSelectors = {
  gridData: (state) => state.gridData,
  item: (state) => state.item,
  update: (state) => state.update,
}
